import heic2any from 'heic2any'

export const convertHeicToJpeg = async (file: File): Promise<File> => {
  // Check if the file is HEIC format
  if (
    file.type === 'image/heic' ||
    file.type === 'image/heif' ||
    file.name.toLowerCase().endsWith('.heic') ||
    file.name.toLowerCase().endsWith('.heif')
  ) {
    try {
      // Convert HEIC to JPEG
      const convertedBlob = (await heic2any({
        blob: file,
        toType: 'image/jpeg',
        quality: 0.8,
      })) as Blob

      // Create a new file with .jpg extension
      const fileName = file.name.replace(/\.(heic|heif)$/i, '.jpg')
      return new File([convertedBlob], fileName, { type: 'image/jpeg' })
    } catch (error) {
      console.error('Error converting HEIC to JPEG:', error)
      throw new Error('Failed to convert HEIC image to JPEG')
    }
  }

  // If not HEIC, return the original file
  return file
}
